import { GetBeneficiarySchema } from 'shared/data/webApp/v1';

export const getMiscKeys = (keysExclude: string[], fields: GetBeneficiarySchema['response']['schema']['fields']) =>
    fields.reduce<string[]>((acc, field) => {
        if (!keysExclude.includes(field.path)) {
            acc.push(field.path);
        }

        return acc;
    }, []);

export const mapKeysToFields = (keys: string[], fields: GetBeneficiarySchema['response']['schema']['fields']) =>
    keys.reduce<GetBeneficiarySchema['response']['schema']['fields']>((acc, key) => {
        const field = fields.find((field) => field.path === key && field.enabled);

        if (field) {
            acc.push(field);
        }

        return acc;
    }, []);
